import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ProformaEmployeeCostReportDTO } from "../../../../models/proforma-employee-cost-report/proforma-employee-cost-report-dto";
import { CustomDate } from "../../../../models/custom-date/custom-date";
import { Container, Field, Label, FromToContainer } from "./styles";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { StyledTextField, StyledDateTextField } from "./styles";
import AutocompleteDropdown from "../../../../reusable-components/AutocompleteDropdown/AutocompleteDropdown";
import { CompanyLegalEntitiesApiService } from "../../../../services/company-legal-entities";
import { CompanyLegalEntityDTO } from "../../../../models/company-accounts/company-legal-entities";
import { CurrenciesApiService } from "../../../../services/currencies/currencies-api.service";
import { ProformaEmployeeCostReportContext } from "../ProformaEmployeeCostReport";
import { Grid, Typography } from "@mui/material";
import { LegislationEmployeeCostConfigurationTypeApiService } from "../../../../services/legislation-employee-cost-configuration-type/legislation-employee-cost-configuration-type-api.service";
import { LegislationEmployeeCostConfigurationTypeDTO } from "../../../../models/legislation-employee-cost-configuration-type/legislation-employee-cost-configuration-type-dto";
import { LegislationEmployeeCostConfigurationTypeFilter } from "../../../../models/legislation-employee-cost-configuration-type/legislation-employee-cost-configuration-type-filter";
interface Props {
  handleUpdateGeneralInfo: (
    field: keyof ProformaEmployeeCostReportDTO,
    value: ProformaEmployeeCostReportDTO[keyof ProformaEmployeeCostReportDTO]
  ) => void;
  handleUpdateLegalEntity: (legalEntity: CompanyLegalEntityDTO | null) => void;
  handleUpdateConfigurationType: (configurationType: LegislationEmployeeCostConfigurationTypeDTO | null) => void;
}
const EmployeeCostHeader = ({
  handleUpdateGeneralInfo,
  handleUpdateLegalEntity,
  handleUpdateConfigurationType,
}: Props) => {
  const { t } = useTranslation();
  const tRP = "components.add_edit_proforma_employee_cost_report";

  const { report, viewMode } = useContext(ProformaEmployeeCostReportContext);
  return report ? (
    <Grid style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
      <Container>
        <Field>
          <Label>{`${t(`common_words.legal_entity`)}`}</Label>
          <AutocompleteDropdown
            field={"legalEntity"}
            serviceApi={new CompanyLegalEntitiesApiService()}
            selectedValue={report.legalEntity}
            handleChange={(field, value) => {
              handleUpdateLegalEntity(value);
            }}
            inputStyle={{
              minWidth: "300px",
              maxWidth: "300px",
              padding: "3px",
              borderRadius: "8px",
            }}
            disabled={viewMode}
            resetToSelectedValueOnBlur
          />
        </Field>
        {report.legalEntity?.legislation && (
          <Field>
            <Label>{`${t(`${tRP}.fields.configuration_type`)}`}</Label>
            <AutocompleteDropdown
              field={"legislationEmployeeCostConfigurationType"}
              serviceApi={new LegislationEmployeeCostConfigurationTypeApiService()}
              selectedValue={report.legislationEmployeeCostConfigurationType}
              handleChange={(field, value) => handleUpdateConfigurationType(value)}
              inputStyle={{
                minWidth: "300px",
                maxWidth: "300px",
                padding: "3px",
                borderRadius: "8px",
              }}
              disabled={viewMode}
              propsFilter={
                {
                  legislationIds: report.legalEntity?.legislation ? [report.legalEntity?.legislation.id] : [],
                } as LegislationEmployeeCostConfigurationTypeFilter
              }
            />
          </Field>
        )}

        {/* <Field>
          <Label>Project</Label>
          <StyledTextField
            value={report.project}
            onChange={(event) => {
              handleUpdateGeneralInfo("project", event.target.value as string);
            }}
            disabled={viewMode}
          />
        </Field>
        <Field>
          <Label>Employee</Label>
          <StyledTextField
            value={report.employee}
            onChange={(event) => {
              handleUpdateGeneralInfo("employee", event.target.value as string);
            }}
            disabled={viewMode}
          />
        </Field> */}
        <Field>
          <Label>{`${t(`${tRP}.fields.description`)}`}</Label>
          <StyledTextField
            value={report.description}
            minRows={2}
            onChange={(event) => {
              handleUpdateGeneralInfo("description", event.target.value as string);
            }}
            // style={{width : "200px"}}
          />
        </Field>
      </Container>
      <Container>
        <Field>
          <Label>{`${t(`${tRP}.fields.currency`)}`}</Label>
          <AutocompleteDropdown
            field={"currency"}
            selectedValue={report.currency}
            serviceApi={new CurrenciesApiService()}
            handleChange={handleUpdateGeneralInfo}
            labelKey={`${t(`${tRP}.fields.currency`)}`}
            noLabel={true}
            fieldProp="code"
            inputStyle={{
              minWidth: "150px",
              maxWidth: "150px",
              padding: "2px",
              borderRadius: "8px",
            }}
            disabled={viewMode}
          />
        </Field>
        <FromToContainer>
          <Field>
            <Label>{`${t(`${tRP}.fields.valid_as_of`)}`}</Label>
            <DesktopDatePicker
              value={CustomDate.ToDate(report.applicableFrom)}
              onChange={(value) => {
                !!value && handleUpdateGeneralInfo("applicableFrom", CustomDate.FromDate(new Date(value)));
              }}
              renderInput={(params) => (
                <StyledDateTextField
                  {...params}
                  sx={{ width: "150px" }}
                  required={true}
                />
              )}
              disabled={viewMode}
            />
          </Field>
          {/* <Field>
            <Label>To</Label>
            <DesktopDatePicker
              value={CustomDate.ToDate(report.applicableTo)}
              onChange={(value) => {
                value
                  ? handleUpdateGeneralInfo("applicableTo", CustomDate.FromDate(new Date(value)))
                  : handleUpdateGeneralInfo("applicableTo", value);
              }}
              renderInput={(params) => (
                <StyledDateTextField
                  {...params}
                  sx={{ width: "150px" }}
                  required={true}
                />
              )}
              disabled={viewMode}
            />
          </Field> */}
        </FromToContainer>
      </Container>
    </Grid>
  ) : (
    <Typography>{`${t(`${tRP}.no_report`)}`}</Typography>
  );
};
export default EmployeeCostHeader;
